import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
import '../css/CustomCard.css';
import '../css/Colors.css';
import '../css/horizontalmenu.css';
import VideoComponent from '../components/VideoComponent';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from '../config/axiosConfig';
import auth from '../auth'
import { withRouter, Redirect } from "react-router-dom";
import { sha256, sha224 } from 'js-sha256';

const userChannel = new BroadcastChannel('user');

class LoginNew extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openModel: false,
            fpModel: false,
            username: '',
            password: '',
            rememberme: '',
            CustomerName: '',
            CustomerPhone: '',
            CustomerEmail: '',
            CompanyName: '',
            showPassword: false,
            fpEmail: '',
            IsShellCustomerNo: '',
            IsShellCustomerYes: '',
            IsShellCardCustomer: '',

            IsTPLCustomerNo: '',
            IsTPLCustomerYes: 'Yes',
            IsTPLCardCustomer: 'Yes',

            IsOneShellCardForOneVehicle: '',
            IsOneShellCardForMultipleVehicle: '',
            IsOneShellCardForOneVehicle_final: '',
            final_IsShellCardCustomer: false,
            final_IsTPLCardCustomer: false,
            final_IsOneShellCardForOneVehicle_final: false,

            showEye: false,
            other:'',
            showOtherInput: false

        };

        this.showModel = this.showModel.bind(this)
        this.closeModel = this.closeModel.bind(this)
        this.onChange = this.onChange.bind(this)
        this.submitLogin = this.submitLogin.bind(this)
        this.submitRegistrationRequest = this.submitRegistrationRequest.bind(this)
        this.toggleShowPassword = this.toggleShowPassword.bind(this) 
        this.toggleShowEye = this.toggleShowEye.bind(this)

        this.showfpModel = this.showfpModel.bind(this)
        this.closefpModel = this.closefpModel.bind(this)
        this.submitForgetPasswordRequest = this.submitForgetPasswordRequest.bind(this)
        this.OnChangeShellCardCustomer = this.OnChangeShellCardCustomer.bind(this)
        this.OnChangeTPLCardCustomer = this.OnChangeTPLCardCustomer.bind(this)
        this.OnChangeCardUsage = this.OnChangeCardUsage.bind(this)
        this.OnChangeOther = this.OnChangeOther.bind(this)

    }
    
    
    showfpModel(e) {
        this.setState({ fpModel: true });
    }

    closefpModel(e) {
        this.setState({ fpModel: false });
    }

    showModel(e) {
        this.setState({ openModel: true });
    }

    closeModel(e) {
        this.setState({ openModel: false });
    }

    onChange(e) {
        this.setState(
            { [e.target.name]: e.target.value }
        )

    }

    OnChangeOther(e){
        this.setState(
            { [e.target.name] : e.target.value }
        )

    }

    submitLogin(e) {
        debugger
        e.preventDefault()
        const data = {
            Email: this.state.username,
            Password: sha256(this.state.password),
            CheckBox: this.state.rememberme
        }

        axiosConfig.post('User/AccountLogin', data)
            .then(res => {
                debugger
                localStorage.clear()
                if (data.CheckBox === 'remember') {
                    localStorage.setItem("token", res.data.token.token)
                    localStorage.setItem("userid", res.data.user.userID)
                    localStorage.setItem("tokenData", JSON.stringify(res.data.token))
                    localStorage.setItem("userData", JSON.stringify(res.data.user))
                    localStorage.setItem("isBranchSelected", false)
                    localStorage.setItem("selectedBranch", '')

                }
                else {
                    
                    localStorage.setItem("token", res.data.token.token)
                    localStorage.setItem("userid", res.data.user.userID)
                    localStorage.setItem("tokenData", JSON.stringify(res.data.token))
                    localStorage.setItem("userData", JSON.stringify(res.data.user))
                    localStorage.setItem("isBranchSelected", false)
                    localStorage.setItem("selectedBranch", '')
                }

                userChannel.postMessage({
                    userId: "res.data.user.userID", // If the user opened your app in multi-tabs and signed-in with multi accounts, you need to put the userId here to identify which account has signed out exactly
                    payload: {
                        type: "SIGN_IN"
                    }
                });
                this.props.LoginHandler({ token: res.data.token.token, userID: res.data.user.userID })
                axiosConfig.defaults.headers.common['Token'] = res.data.token.token;
                auth.login(() => {

                    this.props.history.push("/AccountSelection")


                })



            }
            )
            .catch(function (error) {
                Swal.fire({
                    title: 'Something went wrong', //error.response.data.errorMessage,
                    text: error.response.data.errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
            );


    }


    async OnChangeShellCardCustomer(e) {


        if (e.target.value == "IsShellCustomerYes" & e.target.checked) {
            await this.setState({ IsShellCustomerNo: '' });
            await this.setState({ IsShellCustomerYes: 'Yes' });
            await this.setState({ IsShellCardCustomer: 'Yes' });
        }
        else if (e.target.value == "IsShellCustomerNo" & e.target.checked) {

            await this.setState({ IsShellCustomerNo: 'No' });
            await this.setState({ IsShellCustomerYes: '' });
            await this.setState({ IsShellCardCustomer: 'No' });
        }


        console.log("check box value", this.state.IsShellCardCustomer);
        //this.setState({ openModel: false });

    }

    async OnChangeTPLCardCustomer(e) {


        // if (e.target.value == "IsTPLCustomerYes" & e.target.checked) {
        //     await this.setState({ IsTPLCustomerNo: '' });
        //     // await this.setState({ IsTPLCustomerYes: 'Yes' });
        //     await this.setState({ IsTPLCardCustomer: 'Yes' });
        // }
        // else if (e.target.value == "IsTPLCustomerNo" & e.target.checked) {
        //     await this.setState({ IsTPLCustomerNo: 'No' });
        //     // await this.setState({ IsTPLCustomerYes: '' });
        //     await this.setState({ IsTPLCardCustomer: 'No' });
        // }


        console.log("check box value", this.state.IsTPLCardCustomer);
        //this.setState({ openModel: false });


        const value = e.target.value;

  // If the selected value is "Specify Others", show the input
  if (value === "Specify Others") {
    this.setState({ IsTPLCustomerYes: '', IsTPLCustomerNo:'Yes', showOtherInput: true,other : '',IsTPLCardCustomer: 'No' });
  } else {
    this.setState({ IsTPLCustomerYes: 'Yes',IsTPLCustomerNo:'', showOtherInput: false ,other : '',IsTPLCardCustomer: 'Yes'});
  }

    }

    async OnChangeCardUsage(e) {


        if (e.target.value == "IsOneShellCardForOneVehicle" & e.target.checked) {



            await this.setState({ IsOneShellCardForOneVehicle: 'Yes' });
            await this.setState({ IsOneShellCardForMultipleVehicle: '' });
            await this.setState({ IsOneShellCardForOneVehicle_final: 'Yes' });
        }
        else if (e.target.value == "IsOneShellCardForMultipleVehicle" & e.target.checked) {

            await this.setState({ IsOneShellCardForOneVehicle: '' });
            await this.setState({ IsOneShellCardForMultipleVehicle: 'Yes' });
            await this.setState({ IsOneShellCardForOneVehicle_final: 'No' });
        }


        console.log("check box value", this.state.IsOneShellCardForOneVehicle);
        //this.setState({ openModel: false });

    }
    
    submitRegistrationRequest = e => {
    // async submitRegistrationRequest(e) {

        e.preventDefault();
        debugger
        let IsShellCustomer = false;
        let IsTPLCustomer = false;
        let IsOneShellCardForOneVehicle = false;

        if (this.state.IsShellCardCustomer == "Yes") {
             this.setState({ final_IsShellCardCustomer: true });
        }
        else {
             this.setState({ final_IsShellCardCustomer: false });
        }

        if (this.state.IsTPLCardCustomer == "Yes") {
             this.setState({ final_IsTPLCardCustomer: true });
        }
        else {
             this.setState({ final_IsTPLCardCustomer: false });
        }

        if (this.state.IsOneShellCardForOneVehicle_final == "Yes") {
             this.setState({ final_IsOneShellCardForOneVehicle_final: true });
        }
        else {
             this.setState({ final_IsOneShellCardForOneVehicle_final: false });
        }

        const data = {
            CustomerName: this.state.CustomerName,
            CustomerPhone: this.state.CustomerPhone,
            CustomerEmail: this.state.CustomerEmail,
            CompanyName: this.state.CompanyName,
            IsShellCustomer: this.state.final_IsShellCardCustomer,
            IsTPLCustomer: this.state.final_IsTPLCardCustomer,
            IsOneVehicleForOneCard: this.state.final_IsOneShellCardForOneVehicle_final,
            Other:this.state.other
        }


        axiosConfig.post('Accounts/AccountGenerationRequest', data)
            .then(res => {

                debugger;
                this.setState({ openModel: false });

                Swal.fire({
                    icon: 'success',
                    title: 'Successfully Submitted',
                    text: 'Your request has been successfully submitted. Tracking id is ' + res.data.trackingID,
                })

                this.setState({CustomerName:'',
                    CustomerPhone:'',
                    CustomerEmail: '',
                    CompanyName: '',
                    IsShellCustomer: '',
                    IsTPLCustomer: '',
                    IsOneVehicleForOneCard: '',
                    other:''})
            }
            )
            .catch(function (error) {
            }
            );
    }

    submitForgetPasswordRequest(e) {
        var self = this;
        e.preventDefault()
        const data = {
            Email: this.state.fpEmail
        }


        axiosConfig.post('User/ForgetPassword', data)
            .then(res => {

                this.setState({ fpModel: false });

                Swal.fire({
                    icon: 'success',
                    title: 'Successfully Submitted',
                    text: 'A password reset link has been sent to your registered email address.',
                })
            }
            )
            .catch(function (error) {
                self.setState({ fpModel: false });
                Swal.fire({
                    title: 'Warning', //error.response.data.errorMessage,
                    text: 'Email Is Incorrect.',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
            );
    }




    toggleShowPassword() {
        this.setState({ showPassword: !this.state.showPassword })
    }

    toggleShowEye() {

    console.log('onFicus hit');

        this.setState({ showEye: !this.state.showEye })
    }

    render() {

        if (auth.isAuthenticated()) {
            return (
                //this.props.history.push("/AccountSelection")
                <Redirect to='/AccountSelection' />
            )
        }

        return (

            <Container>

                <VideoComponent></VideoComponent>

                <div className="row m-0 d-flex justify-content-left align-items-center" style={{ position: "relative", height: "calc(100vh - 50px)" }}>

                    <div className="d-flex justify-content-center align-items-center">

                        <Card style={{ marginLeft: '20px' }}>
                            <Card.Header>
                                <div className="row m-0">

                                    <div className="col-2 m-0">
                                        <img src="imageassets/shell_logo.png" width={37} alt="logo" />
                                    </div>

                                    <div className="col-8">
                                        <h5 className="text-center"> Shell Telematics </h5>
                                    </div>

                                    <div className="col-2 p-0">
                                        <img src="imageassets/flag.png" className="effect8" width={45} />
                                    </div>
                                </div>
                            </Card.Header>

                            <Card.Body>
                                <form onSubmit={this.submitLogin}> 
                                    <div class="form-group">
                                        <input type="Email" className="form-control" id="user-name" name="username" placeholder="Username" onChange={this.onChange} required />
                                    </div>
                                    <div class="form-label-group input-group ">
                                        <input type={this.state.showPassword ? "text" : "password"} className="form-control has-feedback-right" id="user-password" name="password" placeholder="Password" onChange={this.onChange} required onFocus={this.toggleShowEye} onFocusOut={this.toggleShowEye}/>
                                        <div className="form-control-position" >
                                             <FeatherIcon show={this.state.showEye} color="black" icon="eye" size="15" onClick={() => this.toggleShowPassword()} />
                                        </div>  
                                    </div>

                                    <div className="row">
                                        <button style={{ width: '100%' }} className="btn btn-shell float-right btn-inline">Login</button>
                                    </div>

                                    <div className="row justify-content-center mb-0">
                                        <p id="forgot2" data-toggle="modal" onClick={this.showfpModel}> <a> Forgot Password </a></p>
                                    </div>

                                    <div className="row justify-content-center mt-0">
                                        <p id="forgot2" data-toggle="modal" onClick={this.showModel}> <a>Not an Existing Shell Telematics User? <br></br>Click Here To Request A Call Back </a> </p>
                                    </div>
                                </form>

                            </Card.Body>

                            <Card.Footer>
                                <div className="footer-btn">
                                    <a href="https://www.shell.com.pk/terms-of-use/general-terms-and-conditions-for-shell-card.html" id="term">Terms &amp; Conditions | </a>
                                    <a href="https://www.shell.com.pk/privacy.html" id="term">Privacy Policy | </a>
                                    <a href="https://www.shell.com.pk/cookie-policy.html" id="term">Cookie Policy |  </a>
                                    <a href="https://www.shell.com.pk/shell-fuel-card/shell-fuel-card/shell-fuel-card-contacts.html" id="term">Contact Us</a>
                                </div>
                                <div className="text-center ">
                                    <div className="d-block d-md-inline-block"><small className="font-weight-bold">Powered by <a className="text-bold-400 grey darken-2" href="https://altpay.biz/" target="_blank">ALTPAY</a></small></div>
                                </div>

                            </Card.Footer>
                        </Card>

                        <Modal show={this.state.fpModel} onHide={this.closefpModel} animation={true} centered style={{ zIndex: 99999 }}>
                            <Modal.Header closeButton>
                                <Modal.Title>Forgot Password</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <form onSubmit={this.submitForgetPasswordRequest}>
                                    <div className="modal-body">
                                        <label>Please Enter a Valid Email: </label>
                                        <div className="form-group">
                                            <input type="Email" placeholder="Enter a valid email address" className="form-control" name="fpEmail" value={this.state.fpEmail} onChange={this.onChange} required />
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <Button variant="secondary" onClick={this.closefpModel}>Close</Button>
                                        <button className="btn btn-shell">Submit</button>
                                    </div>
                                </form>
                            </Modal.Body>
                        </Modal>

                        {/* <Modal show={false} onHide={this.closeModel} animation={true} centered style={{ zIndex: 99999 }}>
                            <Modal.Header closeButton>
                                <Modal.Title>Customer Detail</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <form onSubmit={this.submitRegistrationRequest}>
                                    <div className="modal-body">
                                        <label>Your Name: </label>
                                        <div className="form-group">
                                            <input type="text" placeholder="Enter Your Name" className="form-control" name="CustomerName" value={this.state.CustomerName} onChange={this.onChange} maxLength="50" required />
                                        </div>
                                        <label>Phone Number: </label>
                                        <div className="form-group">
                                            <input placeholder="Enter Contact No" className="form-control" name="CustomerPhone" value={this.state.CustomerPhone} onChange={this.onChange} pattern= "^03[0-9]{2}[0-9]{7}$"  required />
                                        </div>
                                        <label>Email </label>
                                        <div className="form-group">
                                            <input type="email" placeholder="Enter Email Address" className="form-control" name="CustomerEmail" value={this.state.CustomerEmail} onChange={this.onChange} required />
                                        </div>
                                        <label>Your Company Name </label>
                                        <div className="form-group">
                                            <input placeholder="Enter Your Company Name" className="form-control" name="CompanyName" value={this.state.CompanyName} onChange={this.onChange} required maxlength={50} />
                                        </div>
                                        <label>Are you a Shell Card Customer?</label>
                                        <ul className="list-unstyled mb-0">
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">


                                                        <input type="radio" name="vueradisize" id="IsShellCustomerYes" defaultValue="false" value="IsShellCustomerYes" onChange={this.OnChangeShellCardCustomer} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>Yes</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">
                                                        <input type="radio" name="vueradisize" defaultValue="false" id="IsShellCustomerNo" value="IsShellCustomerNo" onChange={this.OnChangeShellCardCustomer} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>No</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                        </ul>

                                        {/* <label>Are you a TPL Trakker Customer ?</label>
                                        <ul className="list-unstyled mb-0">
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">
                                                        <input type="radio" name="TPLCustomer" defaultValue="false" id="IsTPLCustomerYes" value="IsTPLCustomerYes" onChange={this.OnChangeTPLCardCustomer} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>Yes</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">
                                                        <input type="radio" name="TPLCustomer" defaultValue="false" id="IsTPLCustomerNo" value="IsTPLCustomerNo" onChange={this.OnChangeTPLCardCustomer} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>No</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                        </ul> */}
                                        {/* <label>Which Tracking Company’s Trackers are you using?</label>
                                        <div className="form-group">
  <select
    className="form-control"
    name="TPLCustomer"
    value={this.state.TPLCustomer}
    onChange={this.OnChangeTPLCardCustomer}
  >
    <option value="">Select an option</option>
    <option value="IsTPLCustomerYes">TPL Trakker</option>
    <option value="Specify Others">Specify Others</option>
  </select>
  <br/>

  {/* Conditionally render the label and input */}
  {/* {this.state.showOtherInput && (
    <div>
      <label htmlFor="other">Specify Others</label><br/>
      <input type="text" name="other" value={this.state.other} onChange={this.OnChangeOther}></input>
    </div>
  )}
</div>




                                        <label>Do You Use </label>
                                        <ul className="list-unstyled mb-0">
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">
                                                        <input type="radio" name="use" defaultValue="false" id="IsOneShellCardForOneVehicle" value="IsOneShellCardForOneVehicle" onChange={this.OnChangeCardUsage} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>1 Shell Card For 1 Vehicle</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">
                                                        <input type="radio" name="use" defaultValue="false" id="IsOneShellCardForMultipleVehicle" value="IsOneShellCardForMultipleVehicle" onChange={this.OnChangeCardUsage} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>1 Shell Card For Multiple Vehicles</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                        </ul>

                                    </div>
                                    <div className="modal-footer">
                                        <Button variant="secondary" onClick={this.closeModel}>Close</Button>
                                        <button className="btn btn-shell" type="submit" onClick={this.submitRegistrationRequest}>Submit</button>
                                    </div>
                                </form>
                            </Modal.Body>
                        </Modal> */}

                        <Modal show={this.state.openModel} onHide={this.closeModel} animation={true} centered style={{ zIndex: 99999 }}>
    <Modal.Header closeButton>
        <Modal.Title>Customer Detail</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <form onSubmit={this.submitRegistrationRequest}>
            <div className="modal-body">
                <label htmlFor="CustomerName">Your Name:</label>
                <div className="form-group">
                    <input
                        type="text"
                        id="CustomerName"
                        placeholder="Enter Your Name"
                        className="form-control"
                        name="CustomerName"
                        value={this.state.CustomerName}
                        onChange={this.onChange}
                        maxLength={50}
                        required
                    />
                </div>
                <label htmlFor="CustomerPhone">Phone Number:</label>
                <div className="form-group">
                    <input
                        type="tel"
                        id="CustomerPhone"
                        placeholder="Enter Contact No"
                        className="form-control"
                        name="CustomerPhone"
                        value={this.state.CustomerPhone}
                        onChange={this.onChange}
                        pattern="^03[0-9]{2}[0-9]{7}$"
                        required
                    />
                </div>
                <label htmlFor="CustomerEmail">Email:</label>
                <div className="form-group">
                    <input
                        type="email"
                        id="CustomerEmail"
                        placeholder="Enter Email Address"
                        className="form-control"
                        name="CustomerEmail"
                        value={this.state.CustomerEmail}
                        onChange={this.onChange}
                        required
                    />
                </div>
                <label htmlFor="CompanyName">Your Company Name:</label>
                <div className="form-group">
                    <input
                        type="text"
                        id="CompanyName"
                        placeholder="Enter Your Company Name"
                        className="form-control"
                        name="CompanyName"
                        value={this.state.CompanyName}
                        onChange={this.onChange}
                        maxLength={50}
                        required
                    />
                </div>
                <label>Are you a Shell Card Customer?</label>
                                        <ul className="list-unstyled mb-0">
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">


                                                        <input type="radio" name="vueradisize" id="IsShellCustomerYes" defaultValue="false" value="IsShellCustomerYes" onChange={this.OnChangeShellCardCustomer} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>Yes</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">
                                                        <input type="radio" name="vueradisize" defaultValue="false" id="IsShellCustomerNo" value="IsShellCustomerNo" onChange={this.OnChangeShellCardCustomer} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>No</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                        </ul>

                                        {/* <label>Are you a TPL Trakker Customer ?</label>
                                        <ul className="list-unstyled mb-0">
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">
                                                        <input type="radio" name="TPLCustomer" defaultValue="false" id="IsTPLCustomerYes" value="IsTPLCustomerYes" onChange={this.OnChangeTPLCardCustomer} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>Yes</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">
                                                        <input type="radio" name="TPLCustomer" defaultValue="false" id="IsTPLCustomerNo" value="IsTPLCustomerNo" onChange={this.OnChangeTPLCardCustomer} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>No</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                        </ul> */}
                                        <label>Which Tracking Company’s Trackers are you using?</label>
                                        <div className="form-group">
  <select
    className="form-control"
    name="TPLCustomer"
    value={this.state.TPLCustomer}
    onChange={this.OnChangeTPLCardCustomer}
  >
    <option value="">Select an option</option>
    <option value="IsTPLCustomerYes">TPL Trakker</option>
    <option value="Specify Others">Specify Others</option>
  </select>
  <br/>

  {/* Conditionally render the label and input */}
  {this.state.showOtherInput && (
    <div>
      <label htmlFor="other">Specify Others</label><br/>
      <input type="text" name="other" value={this.state.other} onChange={this.OnChangeOther}></input>
    </div>
  )}
</div>




                                        <label>Do You Use </label>
                                        <ul className="list-unstyled mb-0">
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">
                                                        <input type="radio" name="use" defaultValue="false" id="IsOneShellCardForOneVehicle" value="IsOneShellCardForOneVehicle" onChange={this.OnChangeCardUsage} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>1 Shell Card For 1 Vehicle</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                            <li className="d-inline-block mr-2">
                                                <fieldset>
                                                    <div className="vs-radio-con vs-radio-warning">
                                                        <input type="radio" name="use" defaultValue="false" id="IsOneShellCardForMultipleVehicle" value="IsOneShellCardForMultipleVehicle" onChange={this.OnChangeCardUsage} />
                                                        <span className="vs-radio">
                                                            <span className="vs-radio--border" />
                                                            <span className="vs-radio--circle" />
                                                        </span>
                                                        <span>1 Shell Card For Multiple Vehicles</span>
                                                    </div>
                                                </fieldset>
                                            </li>
                                        </ul>

                                    </div>
                                   
            <div className="modal-footer">
                <Button variant="secondary" onClick={this.closeModel}>Close</Button>
                <button className="btn btn-shell" type="submit">Submit</button>
            </div>
        </form>
    </Modal.Body>
</Modal>
















                    </div>
                </div>
            </Container>

        );
    }
}

export default LoginNew;